import * as atlas from 'azure-maps-control'

const INTERNAL_COLOR = '#212121'
const EXTERNAL_COLOR = '#757575'

export function accountsWithReceiverLocation (accounts) {
  return accounts.filter(a => a.receiverSpotLatitude != null && a.receiverSpotLongitude != null)
}

export function createAccountLocationMarker (account, typeLabel, distanceLabel) {
  const icon = account.isExternal ? 'mdi-domain' : 'mdi-home'
  const color = account.isExternal ? EXTERNAL_COLOR : INTERNAL_COLOR
  const distanceHtml = distanceLabel
    ? `<p style="font-weight: normal; margin: 3px 0 0; font-family: 'Roboto', sans-serif; font-size: 14px;">${distanceLabel}</p>`
    : ''

  const popup = new atlas.Popup({
    content: `<div style="color: #F9F6DF; font-weight: bold; padding: 7px;">
      <p style="margin-bottom: 2px; font-size: 16px; font-family: 'Roboto', sans-serif;">${account.name}</p>
      <hr style="border: none; border-top: 1px solid rgba(255, 255, 255, 0.3);">
      <p style="font-weight: normal; margin: 3px 0 0; font-family: 'Roboto', sans-serif; font-size: 14px;">${typeLabel}</p>${distanceHtml}
    </div>`,
    pixelOffset: [0, -18],
    closeButton: false,
    showPointer: true,
    fillColor: 'rgba(0, 0, 0, 0.8)'
  })

  return new atlas.HtmlMarker({
    htmlContent: `<div style="width: 30px; height: 30px; border-radius: 50%; background: white; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.45); display: flex; align-items: center; justify-content: center;"><i class="mdi ${icon}" style="font-size: 20px; color: ${color};"></i></div>`,
    anchor: 'center',
    position: [account.receiverSpotLongitude, account.receiverSpotLatitude],
    popup
  })
}
